import React from 'react';
import PropTypes from 'prop-types';

const IntroSection = ({buttonContainer, isKorea}) => {
    return (
        <div className={`introSection ${isKorea ? 'koreanCountry': ''}`}>
            <div className="razor" />
            <div className="rock" />
            <div className="logo">
                {buttonContainer}
            </div>
        </div>
    );
};

IntroSection.propTypes = {
    buttonContainer: PropTypes.node,
    isKorea: PropTypes.bool
}

export default IntroSection;
